import { useAppDispatch, useAppSelector } from 'app/hooks';
import Button from 'components/inputs/button';
import ToggleSwitch from 'components/inputs/toggle-switch';
import { fetchDefaultAdminData } from 'features/admin';
import { useEffect, useState } from 'react';
import axios from 'utils/api';
import { errorModal, successModal } from 'utils/ui';

// Self-contained 'Sizing Bands Enforcement' settings block (AHA-6796 bands
// T2): the on/off gate for applying the sizing bands to the ducted
// filtering path. Seeded OFF by the migration (Geoff D5); absent (older API
// deploy without the seed) hydrates as off. Save takes effect only once the
// migration has run, because the settings PATCH endpoint is UPDATE-only.
export default function SizingBandsEnforcementSettings() {
  const dispatch = useAppDispatch();
  const settings = useAppSelector((state) => state.admin.settings);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!settings) {
      return;
    }
    setEnabled(settings.sizingBandsEnforcement ?? false);
  }, [settings]);

  const handleSave = async () => {
    try {
      await axios.patch('settings', [
        { key: 'sizingBandsEnforcement', value: JSON.stringify(enabled) }
      ]);
      dispatch(fetchDefaultAdminData());
      successModal(`Settings updated.`);
    } catch {
      errorModal('Something went wrong.');
    }
  };

  return (
    <div className='flex flex-col gap-5'>
      <div className='text-xl font-bold text-gray-900'>
        Sizing Bands Enforcement
      </div>
      <div className='text-gray-500'>
        When on, ducted system results are hard-filtered to the sizing-band
        windows above; when off, the bands are not applied.
      </div>
      <div className='flex items-center gap-3'>
        <ToggleSwitch value={enabled} onChange={setEnabled} />
        <span className='text-gray-900'>{enabled ? 'On' : 'Off'}</span>
      </div>
      <div>
        <Button text='Save' color='green' onClick={handleSave} />
      </div>
    </div>
  );
}
